export default {
    agreement_print: "Print agreement",
    agreement_template: "Agreement template",
    agreements: "Agreements",
    are_you_sure_you_want_to_delete_template: "Are you sure you want to delete the template?",
    bite_templates: "Dental occlusion",
    choose_fields_for_autocomplete: "Select the required values for autofill:",
    complaints_templates: "Complaints",
    consents: "Consents",
    contract_template: "Contract template",
    contracts: "Contracts",
    development: "Development",
    development_templates: "Development",
    diseases: "Diseases",
    diseases_templates: "Diseases",
    document_template_word_file_note: "You can attach a word file as a template. In word file placeholders must be marked with $ sign and curly braces and only capital letters should be used. For example: ${FIO_CLIENT}.",
    epikriz_templates: "Epicrisis",
    found_templates_with_diagnosis: "Found templates with diagnosis",
    full_treatment_template: "Еreatment pattern",
    general_template: "Template",
    generate: "Generate",
    generated: "Generated",
    inspection_templates: "Examination",
    medication_templates: "Treatment",
    not_generated: "Not generated",
    objectively_templates: "Objectively",
    plan_treatment_template: "Treatment plan pattern",
    plansurvey: "Survey plan",
    plansurvey_templates: "Survey plan",
    recommendations_templates: "Recommendations",
    refresh_status_in: "Update status in {vendor}",
    research: "Research data",
    research_templates: "Research data",
    researches: "Research",
    see_in_onlinecontract: "See in OnlineContract",
    see_in_trustme: "See in TrustMe",
    see_in_vendor: "See in {vendor}",
    sign_via_onlinecontract: "Sign via OnlineContract",
    sign_via_trustme: "Sign via TrustMe",
    sign_via_vendor: "Sign via {vendor}",
    signed: "Signed",
    signed_via_onlinecontract: "Signed via OnlineContract",
    signed_via_trustme: "Signed via TrustMe",
    standard_diagnoses: "Standard diagnoses",
    subjectively_templates: "Subjectively",
    teeth_medication: "Treatment",
    teeth_plansurvey: "Examination plan",
    teeth_recommendations: "Recommendations",
    templates_treatments_categories: "Treatment templates' categories",
    upload_signed: "Upload signed",
    uploaded: "Uploaded"
}
